import { Toast, toast } from '@opallabs/lapidary'

export const showPptxToast = (
  title: string,
  message: string,
  type: 'success' | 'error'
) => {
  toast((props) => <Toast {...props} message={message} title={title} />, {
    type,
    closeOnClick: true,
    autoClose: 5000,
  })
}

export const trackPptxLaunch = () => {
  window.metrics?.opalTrack?.('PPTX Export Launch Request', {
    category: 'Other',
  })
}
